import upperFirst from 'lodash-es/upperFirst';
import { put, takeEvery } from 'redux-saga/effects';
import { call } from 'typed-redux-saga';
import { ILookupApiResponse, lookupActionCreators } from '..';
import { httpService } from '../../..';
import { executeApiRequest } from '../../asyncUtils';
import { showFailedRequestDialog } from '../../sagaUtils';
import { uiActionCreators } from '../../ui';

function* updateLookupValueSaga(action: ReturnType<typeof lookupActionCreators.updateValue>) {
  yield put(uiActionCreators.showSpinnerDialog());

  const response = yield* call(executeUpdate, action.payload.type, action.payload.value);

  if (response.requestFailed) {
    yield showFailedRequestDialog(response);
  } else if (response.value) {
    yield put(lookupActionCreators.setLookups({ payload: { [action.payload.type]: [response.value] }, partial: true }));
  }

  yield put(uiActionCreators.hideSpinnerDialog());
}

export function* watchUpdateLookupValue() {
  yield takeEvery(lookupActionCreators.updateValue.match, updateLookupValueSaga);
}

async function executeUpdate<T>(type: keyof ILookupApiResponse, value: T) {
  return executeApiRequest<ILookupApiResponse>(() => httpService.post(`/Lookups/${upperFirst(type)}`, value));
}
